import { mdiAccountLock } from '@mdi/js'
import Icon from '@mdi/react'
import type { IconProps } from '.'

const Private = (props: IconProps) => {
    const { filled, color, size = 1, title, ...other } = props
    return (
        <Icon
            data-testid="IconButton__Private"
            path={mdiAccountLock}
            title={title}
            size={size}
            color={color}
            {...other}
        />
    )
}

export default Private
